import { CircularProgress } from '@mui/material';

import { StyledContainer } from '@/shared/ui/Loader/styles';

import { LoaderProps } from './types';

export const Loader = ({
  containerSize = 'medium',
  sx,
  ...otherProps
}: LoaderProps) => {
  return (
    <StyledContainer containerSize={containerSize} sx={sx}>
      <CircularProgress {...otherProps} />
    </StyledContainer>
  );
};
